// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media (orientation: landscape) and (max-height: 500px) {\n.aura-chart-block[data-v-582ed538] {\n        padding: 0.5rem;\n}\n.aura-chart-block h3[data-v-582ed538] {\n        margin-bottom: 0.5rem;\n        font-size: 10px;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
